export interface INewsContentData {
	title: string;
	shortText: string;
	longText: string;
}

export const defaultNewsContentData: INewsContentData = {
	title: "",
	shortText: "",
	longText: "",
}

export const FileUploadItems = [
	{
		key: "imageUrl",
		label: "Web Etkinlik Detay",
		dimensions: "1080x663,1044x601",
		fileSize: "204800",
		fileSizeText: "200kb",
		format: "JPEG"
	},
	{
		key: "smallImageUrl",
		label: "Web Etkinlik Listesi",
		dimensions: "332x332",
		fileSize: "204800",
		fileSizeText: "200kb",
		format: "JPEG"
	},
	{
		key: "mobileSmallImageUrl",
		label: "Mobil Etkinlik Listesi",
		dimensions: "342x200",
		fileSize: "204800",
		fileSizeText: "200kb",
		format: "JPEG"
	},
	{
		key: "mobileImageUrl",
		label: "Mobil Etkinlik Detay",
		dimensions: "768x1024",
		fileSize: "204800",
		fileSizeText: "200kb",
		format: "JPEG"
	},

];

export const InputStyle = {
	height: "40px",
	width: "100%",
	marginBottom: "10px",
};

export const labelStyle: React.CSSProperties = {
	padding: 0,
	fontWeight: "normal",
	width: "220px",
	fontSize: "15px",
};